__turbopack_context__.v({
  "h1": "styleConstants-module__GdVuKq__h1",
  "h1Opt": "styleConstants-module__GdVuKq__h1Opt",
  "h2": "styleConstants-module__GdVuKq__h2",
  "h2Large": "styleConstants-module__GdVuKq__h2Large",
  "h2Opt": "styleConstants-module__GdVuKq__h2Opt",
  "h2Small": "styleConstants-module__GdVuKq__h2Small",
  "h3": "styleConstants-module__GdVuKq__h3",
  "larger": "styleConstants-module__GdVuKq__larger",
  "leftSideTextWrapper": "styleConstants-module__GdVuKq__leftSideTextWrapper",
  "p": "styleConstants-module__GdVuKq__p",
  "pBody": "styleConstants-module__GdVuKq__pBody",
  "pLarge": "styleConstants-module__GdVuKq__pLarge",
  "pLargeGradient": "styleConstants-module__GdVuKq__pLargeGradient",
  "pOpt": "styleConstants-module__GdVuKq__pOpt",
});
